import { useEffect } from 'react';

const NotFound = () => {
  useEffect(() => {
    window.location.href = `${window.location.origin}/home`;
  }, []);

  return null;
};

export default NotFound;
